import React from 'react';

function TermsOfService() {
  return (
    <div className="container mx-auto py-12">
      <h2 className="text-3xl font-semibold text-center mb-6">Terms of Service</h2>
      <p className="text-lg text-gray-700 mb-6">
        By using the NAOGM website, you agree to these Terms of Service. Please read them carefully.
      </p>
      <h3 className="text-xl font-semibold mb-4">Use of Website</h3>
      <p className="text-gray-700 mb-4">
        The content on this website is for informational purposes and to support NAOGM’s mission. You may not reproduce or distribute content without permission.
      </p>
      <h3 className="text-xl font-semibold mb-4">Donations</h3>
      <p className="text-gray-700 mb-4">
        All donations are processed securely and used to further NAOGM’s mission as per our constitution.
      </p>
      <p className="text-gray-700">
        Contact us at info@naogm.org for more information.
      </p>
    </div>
  );
}

export default TermsOfService;